// For Functions v2 (Cloud Run), set REACT_APP_API_BASE_URL to your qrApi Cloud Run URL (or shared API URL).
// No hardcoded cloudfunctions.net — use env so it works with v2.
const BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

/**
 * Fetch mesa data for QR display
 * 
 * ✅ QR ONLY calls this endpoint
 * ❌ QR NEVER talks to Firestore or POS directly
 * 
 * @param ticket - Optional ticket ID (posOrderId). When present, backend ensures mesa matches this ticket (one QR per ticket).
 */
export async function fetchMesaForQR(mesaId: string, ticket?: string) {
  if (!mesaId) {
    throw new Error('mesaId is required')
  }

  const params = new URLSearchParams()
  if (ticket && ticket.trim()) params.set('ticket', ticket.trim())
  const query = params.toString()
  const url = query ? `${BASE_URL}/qrApi/mesa/${mesaId}?${query}` : `${BASE_URL}/qrApi/mesa/${mesaId}`
  const res = await fetch(url)

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Failed to load mesa' }))
    const message = res.status === 403 && (err.blocked || err.error === 'Mesa no disponible')
      ? 'Mesa no disponible'
      : (err.error || 'Failed to load mesa')
    throw new Error(message)
  }

  const data = await res.json()
  
  if (!data.success || !data.mesa) {
    throw new Error('Invalid response from QR API')
  }

  return data.mesa
}
